import React from 'react';

interface MediaEmbedProps {
    url: string | null;
    theme: 'dark' | 'light';
}

export const MediaEmbed: React.FC<MediaEmbedProps> = ({ url, theme }) => {
    const isDark = theme === 'dark';
    const bg = isDark ? 'bg-black' : 'bg-slate-900';

    if (!url) {
        return (
            <div className={`w-full h-full flex flex-col items-center justify-center ${bg} text-slate-500 p-10 text-center`}>
                <svg className="w-16 h-16 mb-4 opacity-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p className="text-xl font-bold font-heading">No hay contenido configurado</p>
                <p className="text-sm mt-2">El administrador no ha proporcionado una URL válida.</p>
            </div>
        );
    }

    // Try to parse youtube links to embed links to prevent cross-origin framing errors
    let embedUrl = url;
    try {
        if (url.includes('youtube.com/watch')) {
            const videoId = new URL(url).searchParams.get('v');
            if (videoId) {
                // Add autoplay, mute (required by browsers), loop
                embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0`;
            }
        } else if (url.includes('youtu.be/')) {
            const videoId = url.split('youtu.be/')[1].split('?')[0];
            if (videoId) {
                embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0`;
            }
        }
    } catch (e) {
        // silent fail, use raw url
    }

    return (
        <div className={`w-full h-full ${bg} flex items-center justify-center overflow-hidden relative fade-in-up animate-fade-in`}>
            <iframe 
                src={embedUrl}
                className="absolute inset-0 w-full h-full border-0 pointer-events-none"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};
